import { format } from 'date-fns';

export const formatDateWithTimezone = (
  date: string | Date,
  timezone: string | undefined,
  formatter: 'short' | 'long' = 'short'
): string => {
  const dateObj = typeof date === 'string' ? new Date(date) : date;
  
  if (!timezone || timezone === 'UTC') {
    return format(dateObj, formatter === 'short' ? 'dd/MM/yyyy HH:mm:ss' : 'dd MMM yyyy HH:mm:ss');
  }

  try {
    const year = dateObj.getUTCFullYear();
    const month = String(dateObj.getUTCMonth() + 1).padStart(2, '0');
    const day = String(dateObj.getUTCDate()).padStart(2, '0');
    const hours = String(dateObj.getUTCHours()).padStart(2, '0');
    const minutes = String(dateObj.getUTCMinutes()).padStart(2, '0');
    const seconds = String(dateObj.getUTCSeconds()).padStart(2, '0');
    
    const utcString = `${year}-${month}-${day}T${hours}:${minutes}:${seconds}Z`;
    const utcDate = new Date(utcString);
    
    const formatterOptions: Intl.DateTimeFormatOptions = {
      timeZone: timezone,
      year: 'numeric',
      month: formatter === 'short' ? '2-digit' : 'short',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false,
    };
    
    const formattedDate = new Intl.DateTimeFormat('en-US', formatterOptions).format(utcDate);
    
    if (formatter === 'short') {
      const match = formattedDate.match(/(\d{1,2})\/(\d{1,2})\/(\d{4}), (\d{2}:\d{2}:\d{2})/);
      if (match) {
        const [, monthStr, dayStr, yearStr, timeStr] = match;
        return `${dayStr}/${monthStr}/${yearStr} ${timeStr}`;
      }
    } else {
      const match = formattedDate.match(/(\w{3})\s+(\d{1,2}),\s+(\d{4}),\s+(\d{2}:\d{2}:\d{2})/);
      if (match) {
        const [, monthStr, dayStr, yearStr, timeStr] = match;
        return `${dayStr} ${monthStr} ${yearStr} ${timeStr}`;
      }
      const match2 = formattedDate.match(/(\d{1,2})\/(\d{1,2})\/(\d{4}), (\d{2}:\d{2}:\d{2})/);
      if (match2) {
        const [, monthStr, dayStr, yearStr, timeStr] = match2;
        const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        const monthIndex = parseInt(monthStr, 10) - 1;
        return `${dayStr} ${monthNames[monthIndex]} ${yearStr} ${timeStr}`;
      }
    }
    
    return format(dateObj, formatter === 'short' ? 'dd/MM/yyyy HH:mm:ss' : 'dd MMM yyyy HH:mm:ss');
  } catch {
    return format(dateObj, formatter === 'short' ? 'dd/MM/yyyy HH:mm:ss' : 'dd MMM yyyy HH:mm:ss');
  }
};
